angular.module("Main").controller("OnlineSalesAngebotController", ["$scope", "$stateParams", "$location", "$q", "$translate", "$window", "BookingService",
    function ($scope, $stateParams, $location, $q, $translate, $window, BookingService) {
        let vm = this;
        vm.parent = $scope.$parent.vm;
        vm.layoutColors = vm.parent.layoutColors;
        vm.angebotId = '';
        vm.angebotSuchen = false;
        vm.personSuchen = false;
        vm.angebotDirekt = false;
        vm.beginAngebot = 0;
        vm.member = {};
        vm.members = [];
        vm.foundMember = false;
        vm.onlineSalesConfig = vm.parent.onlineSalesConfig;
        vm.chooseAngebotSuchen = false;
        vm.choosePersonSuchen = false;
        vm.chooseAngebotStart = false;
        vm.choosenMember = false;
        vm.choosenNewangebotForMember = false;
        vm.choosenMemberAngebot = false;
        vm.selectedFoundAngebot = false;
        vm.angebotSuchenChoosen = false;
        vm.selectedMember = {};
        vm.angebot = true;
        vm.errorFoundAngebot = false;
        vm.choosenMemberAngebot = false;
        vm.selectedFoundAngebot = false;
        vm.memberSelected = false;
        vm.selectedPauschalenWithMembershipZyklus = vm.parent.selectedPauschalenWithMembershipZyklus;
        vm.selectedPauschalenWithMembershipZyklusIds = vm.parent.selectedPauschalenWithMembershipZyklusIds;

        var xxlarge = 2500;
        var xlarge = 2100;
        var large = 1700;
        var medium = 1300;
        var small = 900;
        var xsmall = 700;


        if ($window.innerWidth >= xxlarge) {
            vm.limitLengthAngebot = 7;
        } else if ($window.innerWidth >= xlarge) {
            vm.limitLengthAngebot = 6;
        } else if ($window.innerWidth >= large) {
            vm.limitLengthAngebot = 5;
        } else if ($window.innerWidth >= medium) {
            vm.limitLengthAngebot = 4;
        } else if ($window.innerWidth >= small) {
            vm.limitLengthAngebot = 3;
        } else if ($window.innerWidth >= xsmall) {
            vm.limitLengthAngebot = 2;
        } else {
            vm.limitLengthAngebot = 20;
        }

        vm.step1 = function () {
            vm.choosePersonSuchen = false;
            vm.chooseAngebotStart = false;
            if (!vm.chooseAngebotSuchen) {
                vm.chooseAngebotSuchen = true;
            } else {
                vm.chooseAngebotSuchen = false;
               // vm.step1Border = 'unset';
            }
        };

        vm.step2 = function () {
            vm.chooseAngebotSuchen = false;
            vm.chooseAngebotStart = false;
            if (!vm.choosePersonSuchen) {
                vm.choosePersonSuchen = true;
               // vm.step2Border = '5px solid '  + vm.onlineSalesConfig.ItemsGewaehltRahmenFarbe + ' !important';
            } else {
                vm.choosePersonSuchen = false;
               // vm.step2Border = 'unset';

            }
        };

        vm.step3 = function () {
            vm.choosePersonSuchen = false;
            vm.chooseAngebotSuchen = false;
            if (!vm.chooseAngebotStart) {
                vm.chooseAngebotStart = true;
                //vm.step3Border = '5px solid ' + vm.onlineSalesConfig.ItemsGewaehltRahmenFarbe + ' !important';
            } else {
                vm.chooseAngebotStart = false;
               // vm.step3Border = 'unset';
            }
        };

        vm.nextStep = function () {
            if(vm.chooseAngebotSuchen) {
                vm.searchAngebot()
            }
            if(vm.choosePersonSuchen) {
                vm.searchPerson()
            }
            if(vm.chooseAngebotStart) {
                vm.startNewAngebot()
            }
        };

        vm.choosePerson = function (member) {
            vm.choosenMember = true;
            vm.selectedMember = member
        };

        vm.goBackToClubs = function () {
            vm.parent.goToClubs();
        };

        vm.goBackActions = function () {
            vm.choosenMember = false;
            vm.choosePersonSuchen = false;
            vm.chooseAngebotSuchen = false;
            vm.chooseAngebotStart = false;
            if (vm.memberSelected || (vm.foundMember === true && vm.members.length > 0)) {
                vm.index = 6;
                vm.angebotId = '';
                vm.memberSelected = false;
                vm.personSuchen = true;
                vm.angebotDirekt = false;
                vm.member = {};
                vm.foundMember = false;
                vm.angebotSuchenFound = false;
                vm.members = []
            } else {
                vm.index = 6;
                vm.angebotId = '';
                vm.angebotSuchen = false;
                vm.angebotSuchenChoosen = false;
                vm.personSuchen = false;
                vm.angebotDirekt = false;
                vm.member = {};
                vm.foundMember = false;
                vm.angebotSuchenFound = false;
                vm.members = [];
                vm.errorFoundAngebot = false;
            }
        };

        vm.startNewAngebot = function () {
            startAngebot()
        };

        function startAngebot() {
            vm.angebotDirekt = true;
            vm.parent.goToClubs('clubs',  vm.memberSelected, vm.selectedMember, vm.choosenNewangebotForMember, vm.selectedFoundAngebot, vm.chooseAngebotStart, vm.angebotDirekt,   vm.selectedPauschalenWithMembershipZyklus,
            vm.selectedPauschalenWithMembershipZyklusIds);
            //vm.parent.goToSurveysAngebot('surveys', vm.memberSelected, vm.selectedMember, vm.choosenNewangebotForMember);
        }

        vm.startNewAngebotForPerson = function () {
            vm.selectedMember.title = vm.selectedMember.Geschlecht;
            vm.selectedMember.firstname = vm.selectedMember.Vorname;
            vm.selectedMember.lastname = vm.selectedMember.Nachname;
            vm.selectedMember.email = vm.selectedMember.Email;
            vm.selectedMember.birthday = new Date(vm.selectedMember.Geburtsdatum);
            vm.selectedMember.street = vm.selectedMember.StrasseNr;
            vm.selectedMember.zipcode = vm.selectedMember.Plz;
            vm.selectedMember.city = vm.selectedMember.Stadt;
            vm.selectedMember.mobile = vm.selectedMember.Mobil;
            vm.selectedMember.iban = vm.selectedMember.Iban;
            vm.selectedMember.bic = vm.selectedMember.Bic;
            if( vm.selectedMember.Kontoinhaber) {
                let accountOwner =   vm.selectedMember.Kontoinhaber.split(',');
                let accountOwnerFirstname = accountOwner[1];
                let accountOwnerLastname = accountOwner[0];
                vm.selectedMember.accountOwnerfirstname = accountOwnerFirstname;
                vm.selectedMember.accountOwnerlastname = accountOwnerLastname;
            }
            vm.parent.goToSurveysAngebot('surveys', vm.memberSelected, vm.selectedMember, vm.choosenNewangebotForMember);
        }

        vm.searchAngebot = function () {
            vm.chooseAngebotSuchenWeiter = true;
            vm.personSuchen = false;
            vm.angebotDirekt = false;
            vm.angebotSuchen = true;
        };

        vm.searchAngebotId = function (angebotId) {
            if(!angebotId) {
                return
            }
            vm.angebotSuchen = true;
            vm.angebotSuchenFound = true;
            BookingService.searchAngebotById(angebotId, $stateParams.abt).then(function (data) {
                let datum  = data.Angebot.Datum;
                let angebotId = data.Angebot.AngebotId;
                vm.foundAngebot = angular.fromJson(data.Angebot.Json);
                vm.foundAngebot.Datum = datum;
                vm.foundAngebot.AngebotId = angebotId;
                vm.foundAngebot.Member = data.MemberModel;
                vm.selectedMember = data.MemberModel;
                vm.errorFoundAngebot = false;
            }).catch(function (error) {
                vm.errorFoundAngebot = true;
                //vm.errorFoundAngebotText = error.data.message
                vm.errorFoundAngebotText = "T_Kein_Angebot_gefunden"
            })
        };

        vm.selectMemberAngebot = function (angebot) {
            if(vm.foundAngebot && !vm.selectedFoundAngebot && !vm.choosenMemberAngebot) {
                return
            }
            if(vm.selectedFoundAngebot) {
                angebot.Member = vm.selectedMember;
                if( angebot.Member.Kontoinhaber) {
                    let accountOwner =   angebot.Member.Kontoinhaber.split(',');
                    let accountOwnerFirstname = accountOwner[1];
                    let accountOwnerLastname = accountOwner[0];
                    angebot.Member.accountOwnerfirstname = accountOwnerFirstname;
                    angebot.Member.accountOwnerlastname = accountOwnerLastname;
                }
                goToAngebot(angebot)
            }
            if(vm.choosenMemberAngebot) {
                vm.foundMember = false;
                vm.foundAngebot = {};
                vm.angebotSuchenFound = false;
                let datum  = angebot.Datum;
                let angebotId = angebot.AngebotId;
                angebot = angular.fromJson(angebot.Json);
                angebot.Datum = datum;
                angebot.AngebotId = angebotId;
                angebot.Member = vm.selectedMember;
                if( angebot.Member.Kontoinhaber) {
                    let accountOwner =   angebot.Member.Kontoinhaber.split(',');
                    let accountOwnerFirstname = accountOwner[1];
                    let accountOwnerLastname = accountOwner[0];
                    angebot.Member.accountOwnerfirstname = accountOwnerFirstname;
                    angebot.Member.accountOwnerlastname = accountOwnerLastname;
                }
                goToAngebot(angebot)
            }
        };

        vm.searchPersonByName = function () {
            if (!vm.member.firstname && !vm.member.lastname)
                return;
            if (vm.collapseSearchResult)
                vm.collapseSearchResult = false;
            vm.showDuplicate = false;
            vm.dataLoading = true;
            vm.member.TenantIds = vm.parent.selectedMandantNr;
            BookingService.searchMemberWithProperties(vm.member, $stateParams.abt).then(function (data) {
                vm.title = "T_Suchergebnisse_Sales";
                vm.dataLoading = false;
                vm.members = data;
                vm.foundMember = true;
            }).catch(function (error) {
                vm.errorSearchPerson = true;
                vm.dataLoading = false;
                //ToDo
                vm.errorSearchPersonText = '';
            })
        };

        vm.searchPerson = function () {
            vm.personSuchen = true;
            vm.angebotDirekt = false;
            vm.angebotSuchen = false;
            vm.angebotSuchenChoosen = false;
        };

        function showAngeboteMember(member) {
            vm.angeboteMember = member.Angebote;
            vm.selectedMember.Id = member.MemberModel.Id;
            vm.selectedMember = member.MemberModel;
        }

        function goToAngebot(angebot) {
            angebot.Zusatztarife = angebot.ZusatztarifeOrig;
            angebot.Gebuehren = angebot.GebuehrenOrig;
            angebot.Pauschalen = angebot.PauschalenOrig;
            angebot.Member.Id = vm.selectedMember.Id ? vm.selectedMember.Id : angebot.Member.Id;
            vm.parent.buyMembership(angebot, angebot.MitgliedschaftsNr, angebot.Basistarif,
                angebot.Pflichtgebuehren, angebot.SelectedAdditions, angebot.SelectedPauschalen, angebot.SelectedGebuehren,
                angebot.SelectedAdditionsGesamt, vm.selectedFoundAngebot, vm.choosenMemberAngebot, vm.selectedAngebot, vm.choosenMemberAngebotDatum,
                vm.choosenFoundAngebotDatum)
        }

        vm.moveLeftAngebot = function () {
            // vm.chunkedAngebot = _.chunk(vm.selectedMember.Angebote, vm.limitLengthAngebot);
            // vm.lengthChunkedAngebot = (vm.chunkedAngebot).length;
            vm.beginAngebot--;
            if (vm.beginAngebot < 0) {
                vm.beginAngebot = vm.lengthChunkedAngebot;
            }
            vm.allAngebot = vm.chunkedAngebot[vm.beginAngebot];
        };

        vm.moveRightAngebot = function () {
            // vm.chunkedAngebot = _.chunk(vm.selectedMember.Angebote, vm.limitLengthAngebot);
            // vm.lengthChunkedAngebot = (vm.chunkedAngebot).length;
            vm.beginAngebot++;
            if (vm.beginAngebot === vm.lengthChunkedAngebot) {
                vm.beginAngebot = 0;
            }
            vm.allAngebot = vm.chunkedAngebot[vm.beginAngebot];
        };

        vm.selectPerson = function (memberSelected) {
            vm.memberSelected = true;
            vm.choosenMember = false;
            let member ={}
            BookingService.getMemberAngebote(memberSelected.Id, $stateParams.abt).then(function (angebote) {
                vm.selectedMemberAngebote = angebote;
                member.Angebote = _.orderBy(angebote.Angebote, 'Datum');
                vm.showMoverAngebot = member.Angebote.length > vm.limitLengthAngebot;
                vm.allAngebot = [];
                if (member.Angebote.length < vm.limitLengthAngebot) {
                    vm.limitLengthAngebot = member.Angebote.length
                }
                vm.chunkedAngebot = _.chunk(member.Angebote, vm.limitLengthAngebot);
                vm.lengthChunkedAngebot = (vm.chunkedAngebot).length;
                if ($window.innerWidth >= 700) {
                    for (let i = 0; i < vm.limitLengthAngebot; ++i) {
                        vm.allAngebot.push(member.Angebote[i]);
                    }
                } else {
                    vm.allAngebot = member.Angebote;
                }
                    showAngeboteMember(vm.selectedMemberAngebote)
            })
        }

        vm.chooseNewAngebotAngebotForPerson = function () {
            if(vm.choosenNewangebotForMember) {
                vm.choosenNewangebotForMember = false;
            } else {
                vm.choosenNewangebotForMember = true;
            }
            vm.choosenMemberAngebot = false;
            vm.selectedFoundAngebot = false;
        };

        vm.chooseMemberAngebot = function (angebot, index) {
            vm.choosenNewangebotForMember = false;
            vm.choosenMemberAngebot = true;
            vm.selectedAngebot = angebot;
            vm.choosenMemberAngebotIndex = index;
            vm.choosenMemberAngebotDatum = true;
            vm.choosenFoundAngebotDatum = false;
        };

        vm.chooseFoundAngebot = function (angebot) {
            if(vm.selectedFoundAngebot) {
                vm.selectedFoundAngebot = false;
            } else {
                vm.selectedFoundAngebot = true;
            }
            vm.selectedAngebot = angebot;
            vm.choosenFoundAngebotDatum = true;
            vm.choosenMemberAngebotDatum = false;
        };

    }]);